import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ContactUsComponent } from './contact-us.component';

const routes: Routes = [
  {
    path: '',
    component: ContactUsComponent
  }
];

@NgModule({
  declarations: [ContactUsComponent],
  imports: [RouterModule.forChild(routes), CommonModule],
  exports: [RouterModule],
  providers: []
})
export class ContactUsModule {}
